import { useMsal } from '@azure/msal-react';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { TokenHelper } from '../../TokenHelper';
import {  useTabStyles } from '../Styles/Editor';
import { TeamsState } from '../../store/TeamsState';
import { Button, Link, Spinner, Text, Toast, ToastBody, ToastTitle, ToastTrigger, useToastController } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

interface Webhook {
    type: string,
    url: string,
}
interface WebhookConfig {
    vatNumber:string,
    identificationNumber: string,
    login: string,
    webhooks: Webhook[],
}
interface WebhookConfigResult
{
    prod: WebhookConfig,
    test: WebhookConfig,
}
export const PeppolSettings = () => {
    const { instance } = useMsal();
    const teamsState = useSelector<ApplicationState, TeamsState>((state: ApplicationState) => state.teamsState);
    //const UserLoginState = useSelector<ApplicationState, UserLoginState>((state: ApplicationState) => state.userNeomyticLogin);
    //const { t } = useTranslation();
    //const styles = useEditorStyles();
    const stylesTab = useTabStyles();
    //const { dispatchToast, updateToast } = useToastController("NeoToasterUnique");
    const [webhookConfigResult, setWebhookConfigResult] = React.useState<WebhookConfigResult | undefined>(undefined);
    const { dispatchToast, updateToast } = useToastController("NeoToasterUnique");
    const { i18n } = useTranslation();

    React.useEffect(() => {
        LoadConfig();
    }, [instance, teamsState]);

    const LoadConfig = () => {
        TokenHelper.GetToken(instance, teamsState)
            .then(token => {
                if (token !== null) {
                    fetch(`api/PeppolAdmin`, {
                        method: "get",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: "bearer " + token,
                        },
                        mode: "cors",
                        cache: "default",
                    })
                        .then(response => {
                            if (response.status === 403) {
                                //dispatch({ type: 'RECEIVE_USER_LOGIN_ACCESSDENIED' });
                            }
                            return response.json() as Promise<WebhookConfigResult>;
                        })
                        .then(data => {
                            setWebhookConfigResult(data);
                        });
                }
            });
    };

    const Reconfig = (env: string, type: string) => {
        TokenHelper.GetToken(instance, teamsState)
            .then(token => {
                if (token !== null) {
                    const toastId = (Math.random() + 1).toString(36).substring(7);
                    dispatchToast(
                        <Toast appearance="inverted">
                            <ToastTitle>
                                Peppol Updating Setting...
                            </ToastTitle>
                            <ToastBody>
                                {env + " " + type}
                            </ToastBody>
                        </Toast>,
                        { intent: "info", timeout: -1, position: "top-end", toastId: toastId }
                    );
                    fetch("api/PeppolAdmin/" + env + "/" + type, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: "bearer " + token,
                        },
                        mode: "cors",
                        cache: "default",
                    })
                        .then(response => {
                            if (response.status === 200) {
                                updateToast({
                                    content: (
                                        <Toast appearance="inverted">
                                            <ToastTitle action={
                                                <ToastTrigger>
                                                    <Link>{i18n.t('Dismiss', { ns: "Toasts" })}</Link>
                                                </ToastTrigger>
                                            }>
                                                Peppol Setting update successfull
                                            </ToastTitle>
                                            <ToastBody>
                                                {env + " " + type}
                                            </ToastBody>
                                        </Toast>
                                    ),
                                    intent: "success",
                                    toastId,
                                    timeout: 5000,
                                    pauseOnHover: true,
                                });
                            }
                            else {
                                updateToast({
                                    content: (
                                        <Toast appearance="inverted">
                                            <ToastTitle action={
                                                <ToastTrigger>
                                                    <Link>{i18n.t('Dismiss', { ns: "Toasts" })}</Link>
                                                </ToastTrigger>
                                            }>
                                                Peppol Setting update failed
                                            </ToastTitle>
                                            <ToastBody>
                                                {env + " " + type}
                                            </ToastBody>
                                        </Toast>
                                    ),
                                    intent: "error",
                                    toastId,
                                    timeout: 10000,
                                    pauseOnHover: true,
                                });
                            }
                        });
                }
            });
    };

    return <div className={stylesTab.rootSub}>
        <Button
            onClick={() => {
                LoadConfig();
            }}
        >
            Reload Config
        </Button>

        <h3>Prod</h3>
        <Button
            onClick={() => Reconfig("prod", "webhook")}
        >
            Reconfigure
        </Button>
        {!webhookConfigResult && <Spinner size="extra-tiny" />}
        {webhookConfigResult && webhookConfigResult.prod === null &&
            <Text truncate>No information available</Text>
        }
        {webhookConfigResult && webhookConfigResult.prod !== null && webhookConfigResult.prod.webhooks !== null && webhookConfigResult.prod.webhooks.map((wh) => {
            return <Text truncate>{wh.type + " " + wh.url}</Text>;
        })}
        <h3>Test</h3>
        <Button
            onClick={() => Reconfig("test", "mailto")}
        >
            Reconfigure to email
        </Button>
        <Button
            onClick={() => Reconfig("test", "webhook")}
        >
            Reconfigure to webhook
        </Button>
        {!webhookConfigResult && <Spinner size="extra-tiny" />}
        {webhookConfigResult && webhookConfigResult.test === null &&
            <Text truncate>No information available</Text>
        }
        {webhookConfigResult && webhookConfigResult.test !== null && webhookConfigResult.test.webhooks !== null && webhookConfigResult.test.webhooks.map((wh) => {
            return <Text truncate>{wh.type + " " + wh.url}</Text>;
        })}
    </div>;
};
